module.exports = __webpack_public_path__ + "media/images/pc/specials/common/recommend_green-02bf7c235f3d23def70f8d5a218da1a0.jpg";